//#region types
import { AccountStepProps } from "models/propTypes/incomingInvoicePropTypes";
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { SearchInputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import {
  ExpandableSection,
  ExpandableSectionSummary,
  HorizontalFormField,
  Suggestions,
  SearchInput,
} from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";
import React from "react";
import { SelectionItem } from "models/utilTypes/selectionTypes";

const AccountStep: React.FC<AccountStepProps<IncomingInvoiceFormTypes.Todo>> = (props) => {
  const accountFormProps = props.connect("account");

  const onItemSelect = (item: AutocompleteListItem | SelectionItem) => {
    accountFormProps.setValue(item);
  };

  const filteredSuggestions = props.accountSuggestions?.filter((s) => s.id !== accountFormProps.value?.id) ?? [];

  const child = (
    <Grid container rowGap={1}>
      <HorizontalFormField<SearchInputProps>
        Component={SearchInput}
        {...accountFormProps}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.RefersTo)}
        items={props.getBookingTreeItems}
        error={accountFormProps.hasError}
        disabled={props.invoice.isAutoInvoice}
        noOuterSpacing
        hideMainLabel
        childGridSize={true}
        blurOnSelect
      />
      {!props.invoice.isAutoInvoice && (
        <Suggestions
          setValue={onItemSelect}
          suggestions={filteredSuggestions}
          maxSuggestionsCount={filteredSuggestions.length}
        />
      )}
    </Grid>
  );

  return props.hideAccountSectionLabel ? (
    <Grid container marginBottom={3} marginTop={1}>
      {child}
    </Grid>
  ) : (
    <Grid container marginTop={-1}>
      <ExpandableSection
        summary={
          <ExpandableSectionSummary
            title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.InvoiceCategoryText)}
          />
        }
        initiallyOpen
        hasErrors={accountFormProps.hasErrors}
        {...props.expandableStepProps}
      >
        {child}
      </ExpandableSection>
    </Grid>
  );
};

export default AccountStep;
